import { Module } from 'vuex'
import { StateUi } from './types'
import { RootStore } from '@/store/rootStore'
import i18n from '@/i18n'

const getDefaultStateDialog = () => {
  return {
    open: false,
    component: '',
    props: {}
  }
}

const getDefaultStateModal = () => {
  return {
    open: false,
    component: '',
    props: {}
  }
}

const getDefaultTextMask = () => i18n.t('mask').toString()

const ui: Module<StateUi, RootStore> = {
  namespaced: true,
  state: {
    modal: getDefaultStateModal(),
    dialog: getDefaultStateDialog(),
    mask: {
      text: getDefaultTextMask(),
      show: false
    },
    openedTabs: []
  },
  mutations: {
    toggleMask (state, { text, show }) {
      state.mask = {
        text: text || getDefaultTextMask(),
        show
      }
    },
    openDialog (state, { component, props }) {
      state.dialog.open = true
      state.dialog.component = component
      state.dialog.props = props
    },
    closeDialog (state) {
      state.dialog = getDefaultStateDialog()
    },
    openModal (state, { component, props }) {
      state.modal.open = true
      state.modal.component = component
      state.modal.props = props
    },
    closeModal (state) {
      state.modal = getDefaultStateModal()
    },
    addOpenedTab (state, name) {
      state.openedTabs.push(name)
    },
    removeOpenedTab (state, name) {
      state.openedTabs.splice(state.openedTabs.findIndex(item => item === name), 1)
    }
  },
  actions: {
    showMask ({ commit }, { text } = {}) {
      commit('toggleMask', { text, show: true })
    },
    hideMask ({ commit }) {
      commit('toggleMask', { show: false })
    },
    openDialog ({ commit }, { component, props }) {
      commit('openDialog', { component, props })
    },
    closeDialog ({ commit }) {
      commit('closeDialog')
    },
    openModal ({ commit }, { component, props }) {
      commit('openModal', { component, props })
    },
    closeModal ({ commit }) {
      commit('closeModal')
    },
    addOpenedTab ({ commit }, name) {
      commit('addOpenedTab', name)
    },
    removeOpenedTab ({ commit }, name) {
      commit('removeOpenedTab', name)
    }
  },
  getters: {
    maskInfo (state) {
      return state.mask
    },
    dialogInfo (state) {
      return state.dialog
    },
    modalInfo (state) {
      return state.modal
    },
    openedTabs (state) {
      return state.openedTabs
    }
  }
}

export default ui
